// extracted by mini-css-extract-plugin
module.exports = {"tag-container":"QuestionTag_tag-container__3h1R0","tag-name":"QuestionTag_tag-name__1WYvd","delete-button":"QuestionTag_delete-button__14s6t"};